import React from 'react';
import clsx from 'clsx';

const SideLabel = ({
  label,
  className,
}: {
  label: string;
  className?: string;
}) => {
  return (
    <h3
      className={clsx(
        'text-[32px] md:text-[38px] font-semibold text-center text-dark',
        className
      )}
    >
      {label}
    </h3>
  );
};

export default SideLabel;
